export const STAGES = ['ONLINE', 'IN_PREPARATION', 'FINISHED']
